module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/classic_desktop-8888a54043c2e4af7df9f78f5c04182a.jpg";